import React, { Suspense, lazy, useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useScrollToTop from "./hooks/useScrollToTop.js";
import i18n from "i18next";
import Loading from "./utils/loading.jsx"

// Lazy-loaded components
const MainLayouts = lazy(() => import("./layouts/MainLayouts.jsx"));
const HomePage = lazy(() => import("./page/home.jsx"));
const ContactPage = lazy(() => import("./page/contact.jsx"));
const AboutUsPage = lazy(() => import("./page/AboutUs.jsx"));
const CertificationPage = lazy(() => import("./page/certification.jsx"));
const ProductPage = lazy(() => import("./page/productPage.jsx"));
const ProductDetail = lazy(() => import("./page/productDetail.jsx"));
const ProjectDetail = lazy(() => import("./page/projectDetail.jsx"));
const BlogDetail = lazy(() => import("./page/blog-detail.jsx"));
const JobPage = lazy(() => import("./page/jobPage.jsx"));
const Blog = lazy(() => import("./page/blogPage.jsx"));
const ProjectPage = lazy(() => import("./page/projectPage.jsx"));
const Morefeedback = lazy(() => import("./page/moreCustomerFeedback.jsx"));
const JobDescriptionPage = lazy(() => import("./page/jobDescriptionPage.jsx"));

function App() {
  useScrollToTop();

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === "en" ? "ltr" : "rtl";
  }, [i18n.language]);

  useEffect(() => {
    window.lazySizes.init();
  }, []);

  return (
    <div>
      <Suspense fallback={<div> <Loading/></div>}>
        {" "}
        <MainLayouts>
          <Routes>
            <Route path="/" element={<HomePage />} />{" "}
            <Route path="/contact-us" element={<ContactPage />} />{" "}
            <Route path="/about-us" element={<AboutUsPage />} />{" "}
            <Route path="/certification" element={<CertificationPage />} />{" "}
            <Route path="/product" element={<ProductPage />} />{" "}
            <Route path="/project" element={<ProjectPage />} />{" "}
            <Route path="/product-detail/:id" element={<ProductDetail />} />{" "}
            <Route path="/project-detail/:id" element={<ProjectDetail />} />{" "}
            <Route path="/blog-detail/:id" element={<BlogDetail />} />{" "}
            <Route path="/blogs" element={<Blog />} />{" "}
            <Route path="/job" element={<JobPage />} />{" "}
            <Route
              path="/job-description/:id"
              element={<JobDescriptionPage />}
            />{" "}
            <Route path="/feedbacks" element={<Morefeedback />} />{" "}
            <Route path="*" element={<Navigate to="/" />} />{" "}
          </Routes>{" "}
        </MainLayouts>{" "}
      </Suspense>{" "}
    </div>
  );
}

export default App;
